module.exports = __webpack_public_path__ + "static/media/fullscreen.f86e44c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/fullscreen.svg
// module id = 1126
// module chunks = 21